import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';

const menu = [
  { id: 1, label: "Dashboard", to: "/admin/dashboard" },
  { id: 2, label: "User Management", to: "/admin/user-management" },
  { id: 3, label: "Vendor Management", to: "/admin/vendor-management" },
  { id: 4, label: "Order Management", to: "/admin/admin-orders" },
  { id: 5, label: "Material Management", to: "/admin/admin-materials" },
  { id: 6, label: "Fee Management", to: "/admin/fees-management" },
  { id: 7, label: "Sales Reports", to: "/admin/sales" },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleAdminLogout = async () => {
    try {
      logout();
      
      navigate('/', { 
        state: { 
          message: 'Successfully logged out from admin dashboard',
          type: 'success'
        } 
      });
    } catch (error) {
      console.error('Admin logout error:', error);
      navigate('/');
    }
  };

  return (
    <aside className="w-64 bg-white h-screen flex flex-col border-r">
      {/* Logo Section */}
      <div className="px-6 py-8 flex items-center gap-3">
        <img 
          src="/favicon.svg" 
          alt="Fáàrí Logo" 
          className="h-10 w-10 object-contain"
        />
        <span className="font-bold text-xl text-gray-900">Fáàrí</span>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1">
        <ul className="space-y-1 px-2">
          {menu.map((item) => (
            <li key={item.id}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded-lg transition ${
                    isActive 
                      ? "bg-gray-100 font-semibold text-gray-900" 
                      : "text-gray-700 hover:bg-gray-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Bottom Section */}
      <div className="px-4 py-6 border-t space-y-4">
        <NavLink 
          to="/admin/settings" 
          className="flex items-center gap-3 text-gray-700 hover:text-black"
        >
          Settings
        </NavLink>
        <div className="flex items-center gap-3 text-gray-700">
          Dark Theme
          {/* You can add a toggle switch here */}
        </div>
        <button
          onClick={handleAdminLogout}
          className="flex items-center gap-3 text-red-500 hover:text-red-700 w-full text-left"
        >
          Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;